import {Link} from 'react-router'
import styles from './style.css'

class ReceiptButtonGroup extends React.Component {
  render () {
    let {clickResendButton, invoiceDetail, onClickRecordPayment, onClickPrintButton, onCancelInvoice} = this.props

    return (
      <div className='mk-col-right-action-box bottom invoice'>
        <button
          className={'btn btn-default pull-left resend-invoice ' + styles.resend}
          onClick={clickResendButton} >
          {
            invoiceDetail.invoice_status === 'paid' ? 'Send Receipt' : 'Resend'
          }
        </button>
        <div className={'btn-group pull-right ' + styles['mr-btn']}>
          <button
            aria-expanded='false'
            className='btn btn-default dropdown-toggle invoice'
            data-toggle='dropdown'>
            More&nbsp;
            <b className='caret invoice' />
          </button>
          <ul className='dropdown-menu import-export-menu invoice' role='menu'>
            {
            invoiceDetail.invoice_status !== 'cancelled' &&
            <li onClick={onCancelInvoice}>
              <a>Cancel Invoice</a>
            </li>
          }
            <li onClick={onClickPrintButton}>
              <Link target='_blank'>Print</Link>
            </li>
          </ul>
        </div>
        <button
          className='btn btn-primary mr-20px pull-right'
          id={styles['btn-record-payment']}
          onClick={onClickRecordPayment}
          disabled={this._disabledButton(invoiceDetail.invoice_status)}>
          Record Payment
        </button>
      </div>
    )
  }

  _disabledButton = (status) => {
    if ((status === 'cancelled') || (status === 'paid')) {
      return true
    } else {
      return false
    }
  }
}

ReceiptButtonGroup.propTypes = {
  clickResendButton: React.PropTypes.func,
  invoiceDetail: React.PropTypes.object,
  onClickRecordPayment: React.PropTypes.func,
  onClickPrintButton: React.PropTypes.func,
  onCancelInvoice: React.PropTypes.func
}

export default ReceiptButtonGroup



// WEBPACK FOOTER //
// ./app/components/receipt/invoices/ButtonGroup/ReceiptButtonGroup.js